const Loader: React.FC<React.PropsWithChildren<unknown>> = () => {
  const color = '#7E27BF';

  return (
    <div className="flex-center w-full">
      <svg className="inline-block w-[52px] h-[100px]" enableBackground="new 0 0 0 0">
        <circle fill={color} stroke="none" cx="6" cy="50" r="6">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.1"
          />
        </circle>

        <circle fill={color} stroke="none" cx="26" cy="50" r="6">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.2"
          />
        </circle>

        <circle fill={color} stroke="none" cx="46" cy="50" r="6">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.3"
          />
        </circle>
      </svg>
    </div>
  );
};

export const ButtonLoader = () => (
  <svg version="1.1" id="L4" x="0px" y="0px" width="52px" height="14px">
    <circle fill="#fff" stroke="none" cx="6" cy="6" r="5">
      <animate
        attributeName="opacity"
        dur="1s"
        values="0;1;0"
        repeatCount="indefinite"
        begin="0.1"
      />
    </circle>
    <circle fill="#fff" stroke="none" cx="24" cy="6" r="5">
      <animate
        attributeName="opacity"
        dur="1s"
        values="0;1;0"
        repeatCount="indefinite"
        begin="0.2"
      />
    </circle>
    <circle fill="#fff" stroke="none" cx="42" cy="6" r="5">
      <animate
        attributeName="opacity"
        dur="1s"
        values="0;1;0"
        repeatCount="indefinite"
        begin="0.3"
      />
    </circle>
  </svg>
);

export default Loader;
